export default __webpack_public_path__ + "f0afbc82122891f43ed42f5ae2d61618.png";